import { EmptyInstance } from "core/features/components/mixins/empty-instance";
import { EventEmitterMixin } from "front-end/mixins/event-emitter.mixin";

export class BannerFilterComponent extends EventEmitterMixin(EmptyInstance) {
    public static SELECTOR = ".js-ina-banner-filter";

    private _classMap = {
        css: {
            active: "ina-banners__btn--active"
        }
    };

    private _currentContext: JQuery = $();

    public get bannerId(): string {
        return this._currentContext.data().bannerId as string;
    }

    public toggleActive(state: boolean): void {
        this._currentContext.toggleClass(this._classMap.css.active, state);
    }

    private get isActive(): boolean {
        return this._currentContext.hasClass(this._classMap.css.active);
    }

    public scrollTo(): void {
        const areaPosition = this._currentContext.get(0).offsetTop;
        window.scrollTo({
            top: areaPosition - 100,
            behavior: "smooth"
        });
    }

    private bindEvents(): void {
        this._currentContext.on("click", e => {
            e.preventDefault();
            if (!this.isActive) {
                this.emit("click", this.bannerId);
            }
        });
    }

    public init(context: JQuery): void {
        this._currentContext = context || this._currentContext;

        this.bindEvents();
    }
}
